import { Group, GroupOptionsOverview } from '../../../../graphql/groups.datatypes';
import {makeStyles} from '@material-ui/styles';
import React from 'react';
import {Card, CardContent, CardHeader, colors, Divider, Grid, Theme, Typography} from '@material-ui/core';
import {formatDate} from '../../../../utils/formatters';
import {Resource} from '../../../../graphql/resources.datatypes';
import {getBlankGroup} from '../../GroupDetails/GroupDetails';
import {getGroupOptionsQuery, gqlGroupForOptionsOverviewCardQuery} from '../../getGroupQueries.api';
import {T} from 'react-polyglot-hooks';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    container: {
        marginTop: theme.spacing(3),
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    card: {},
    saveButton: {
        marginLeft: theme.spacing(1),
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        }
    },
    deleteButton: {
        marginLeft: theme.spacing(1),
        color: theme.palette.white,
        backgroundColor: theme.palette.error.light,
        '&:hover': {
            backgroundColor: theme.palette.error.main
        }
    },
    cloneButton: {
        marginLeft: theme.spacing(1),
        color: theme.palette.white,
        backgroundColor: colors.green[400],
        '&:hover': {
            backgroundColor: colors.green[700]
        }
    },
    errorIcon: {
        marginRight: theme.spacing(1),
        color: theme.palette.error.main,
    },
    marginBottom: {
        paddingLeft: theme.spacing(1),
        marginBottom: theme.spacing(3),
    },
    tabs: {
        marginTop: theme.spacing(3)
    },
}));

const getBlankOptionsOverview = (): GroupOptionsOverview[] => {
    return [];
}

const getBlankOptions = () => {
    return {
        data: {
            getGroupOptions: getBlankOptionsOverview()
        },
        error: null,
        loading: false,
    }
}


const OptionsOverviewCard = (props: { group: Group, isAdmin: boolean }) => {
    const {group, isAdmin} = props;
    const classes = useStyles();
    const isNewGroup = group.id === -1
    const groupForOptionsOverviewCardData = isNewGroup ? getBlankOptions() : getGroupOptionsQuery(Number(group.id), gqlGroupForOptionsOverviewCardQuery);
    const groupForOptionsOverviewCard = groupForOptionsOverviewCardData && !groupForOptionsOverviewCardData.loading && groupForOptionsOverviewCardData.data && groupForOptionsOverviewCardData.data.getGroupOptions;

    return (
        <React.Fragment>
            <Card className={classes.container}>
                <CardHeader title={'Options Overview'}/>
                <Divider/>
                <CardContent className={classes.card}>
                    {groupForOptionsOverviewCardData.loading && (
                        <React.Fragment>
                            <Grid item xs={4}>
                                <Typography><T phrase="Loading..."/></Typography>
                            </Grid>
                        </React.Fragment>
                    )}
                    {groupForOptionsOverviewCard && !groupForOptionsOverviewCardData.loading && (
                        <React.Fragment>
                            <Grid container alignItems="center" spacing={1}>
                                <Grid item xs={12}><Typography variant="body1"><b>Room Member Options</b></Typography></Grid>
                                {groupForOptionsOverviewCard && (
                                    <React.Fragment>
                                        {groupForOptionsOverviewCard.length === 0 && (
                                            <Grid item xs={4}>
                                                <Typography><T phrase="No room member option information to show"/></Typography>
                                            </Grid>
                                        )}
                                        {groupForOptionsOverviewCard.length > 0 && groupForOptionsOverviewCard.map(option => {
                                            return option.total_options_count > 0 && (
                                                <Grid key={'member_' + option.id} item xs={12}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={4}><Typography variant="body1">Option: {isAdmin ? option.internal_name : option.display_name}</Typography></Grid>
                                                        <Grid item xs={4}><Typography variant="body1">Count: {option.total_options_count}</Typography></Grid>
                                                    </Grid>
                                                </Grid>
                                            )
                                        })}
                                    </React.Fragment>
                                )}
                            </Grid>

                            <Grid container alignItems="center" spacing={1}>
                                <Grid item xs={12}><Typography variant="body1"><b>Room Options</b></Typography></Grid>
                                {groupForOptionsOverviewCard && (
                                    <React.Fragment>
                                        {groupForOptionsOverviewCard.length === 0 && (
                                            <Grid item xs={4}>
                                                <Typography><T phrase="No room option information to show"/></Typography>
                                            </Grid>
                                        )}
                                        {groupForOptionsOverviewCard.length > 0 && groupForOptionsOverviewCard.map(option => {
                                            return option.room_options_count > 0 && (
                                                <Grid key={'room_' + option.id} item xs={12}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={4}><Typography variant="body1">Option: {option.internal_name}</Typography></Grid>
                                                        <Grid item xs={4}><Typography variant="body1">Count: {option.room_options_count}</Typography></Grid>
                                                    </Grid>
                                                </Grid>
                                            )
                                        })}
                                    </React.Fragment>
                                )}
                            </Grid>
                        </React.Fragment>
                    )}
                </CardContent>
            </Card>
        </React.Fragment>
    );
};

export default OptionsOverviewCard;
